import { html, css } from 'lit';
import { customElement } from 'lit/decorators.js';
import { TmElement } from '@thiememeulenhoff/lit-sdk';
import { tagName } from '../../helpers';

const tag = tagName('logo-icon');

@customElement(tag)
export class LogoIconComponent extends TmElement {
  static override styles = [
    css`
      :host {
        display: block;
        line-height: 0;
      }

      :where(svg) {
        block-size: 100%;
        inline-size: 100%;
      }
    `,
  ];

  override render() {
    return html` <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 39 31"
      preserveAspectRatio="none"
    >
      <path
        d="M7.60349 15.8069L10.9573 0.916929L7.32082 0.487738C6.54016 0.38516 5.74709 0.448101 4.99148 0.672605C4.23587 0.897109 3.53406 1.27832 2.93018 1.79227C2.3263 2.30622 1.8334 2.94179 1.48248 3.65902C1.13156 4.37626 0.930212 5.15964 0.891087 5.95991L0.340104 15.4119C0.143666 18.8259 2.60153 22.474 5.80202 23.5177L7.61308 24.103C6.9872 21.3747 6.98392 18.5367 7.60349 15.8069Z"
        fill="#0090D7"
      />
      <path
        d="M16.7063 6.17927L17.5687 1.71666L13.1321 1.18018C14.0904 2.57504 14.488 5.99881 14.0424 9.66156L12.126 25.5709L19.1642 27.8534L17.0177 19.8938C16.0691 16.353 15.9302 10.1785 16.7063 6.17927Z"
        fill="#95C11F"
      />
      <path
        d="M13.133 1.18036L10.9482 0.916992L7.59441 15.807C6.97243 18.5344 6.97243 21.3707 7.59441 24.0981L12.1029 25.5613L14.0194 9.65199C14.4889 5.99899 14.0816 2.57523 13.133 1.18036Z"
        fill="#009240"
      />
      <path
        d="M25.8386 2.71186L18.4746 1.82422L22.1159 9.75448C23.3041 12.3443 23.9078 18.1822 23.4622 22.7277L22.8441 29.068L23.8024 29.3802C24.936 29.7234 26.1381 29.7581 27.289 29.4808C28.4399 29.2036 29.4992 28.624 30.3615 27.8L26.1405 9.60817C25.6348 7.34636 25.5326 5.01048 25.8386 2.71186Z"
        fill="#E50051"
      />
      <path
        d="M22.1164 9.75436L18.4751 1.82409L17.5696 1.7168L16.7072 6.1794C15.931 10.1787 16.0699 16.3532 17.0186 19.894L19.165 27.8535L22.859 29.0533L23.4771 22.713C23.9083 18.187 23.3046 12.349 22.1164 9.75436Z"
        fill="#A42523"
      />
      <path
        d="M34.3719 3.74055L31.2002 3.36013L26.1455 2.75049L31.4733 16.2797C32.4746 18.8159 32.5944 22.8249 31.8374 25.7366C31.8709 25.6585 31.9141 25.5854 31.9476 25.5024L32.1872 24.9026L38.1186 10.2418C39.3978 7.06678 37.7114 4.14536 34.3719 3.74055Z"
        fill="#F39200"
      />
      <path
        d="M31.4733 16.2802L26.1455 2.75093L25.8389 2.71191C25.5334 5.00893 25.6357 7.34311 26.1407 9.60334L30.3617 27.8C30.9819 27.2195 31.4834 26.5201 31.8374 25.7419C32.58 22.8253 32.4746 18.8163 31.4733 16.2802Z"
        fill="#CD1719"
      />
      <path
        d="M6.03223 10.515H9.28063V20.9717H10.4688H11.7097V10.515H14.9581V8.31055H10.4688H6.03223V10.515Z"
        fill="white"
      />
      <path
        d="M20.2287 8.27148H17.8427H17.8379V20.9326H17.8427H20.2622V13.5535L22.6578 18.3575H24.3012L25.1827 16.5724L26.6728 13.5535V20.9326H29.1019V8.27148H26.7063L25.1827 11.5099L23.4771 15.119L20.2287 8.27148Z"
        fill="white"
      />
    </svg>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'a-logo-icon': LogoIconComponent;
  }
}
